import * as i0 from '@angular/core';
import * as i1 from './table.module';
import * as i2 from './cell';
import * as i3 from './row';
import * as i4 from '../bidi/bidi.module';
import * as i5 from '../platform/platform.module';
export const ElTableModuleNgFactory:i0.NgModuleFactory<i1.ElTableModule> = (null as any);
var _decl0_0:i1.ElTable<any> = (<any>(null as any));
var _decl0_1:i2.ElHeaderCellDefDirective = (<any>(null as any));
var _decl0_2:i3.ElHeaderRowDefDirective = (<any>(null as any));
var _decl0_3:i2.ElColumnDefDirective = (<any>(null as any));
var _decl0_4:i2.ElCellDefDirective = (<any>(null as any));
var _decl0_5:i3.ElRowDefDirective<any> = (<any>(null as any));
var _decl0_6:i2.ElFooterCellDefDirective = (<any>(null as any));
var _decl0_7:i3.ElFooterRowDefDirective = (<any>(null as any));
var _decl0_8:i3.ElDataRowOutletDirective = (<any>(null as any));
var _decl0_9:i3.ElHeaderRowOutletDirective = (<any>(null as any));
var _decl0_10:i3.ElFooterRowOutletDirective = (<any>(null as any));
var _decl0_11:i3.ElCellOutletDirective = (<any>(null as any));
var _decl0_12:i2.ElHeaderCellDirective = (<any>(null as any));
var _decl0_13:i2.ElCellDirective = (<any>(null as any));
var _decl0_14:i2.ElFooterCellDirective = (<any>(null as any));
var _decl0_15:i3.ElHeaderRowComponent = (<any>(null as any));
var _decl0_16:i3.ElRowComponent = (<any>(null as any));
var _decl0_17:i3.ElFooterRowComponent = (<any>(null as any));
var _decl0_18:i4.ElBidiModule = (<any>(null as any));
var _decl0_19:i5.ElPlatformModule = (<any>(null as any));
var _decl0_20:i0.TemplateRef<any> = (<any>(null as any));
var _decl0_21:i0.ElementRef<any> = (<any>(null as any));
function _View_ElTable_Host_1_0():void {
  var _any:any = (null as any);
}
function _View_ElTable_1_0():void {
  var _any:any = (null as any);
}
function _View_ElHeaderRowComponent_Host_2_0():void {
  var _any:any = (null as any);
}
function _View_ElHeaderRowComponent_2_0():void {
  var _any:any = (null as any);
}
function _View_ElRowComponent_Host_3_0():void {
  var _any:any = (null as any);
}
function _View_ElRowComponent_3_0():void {
  var _any:any = (null as any);
}
function _View_ElFooterRowComponent_Host_4_0():void {
  var _any:any = (null as any);
}
function _View_ElFooterRowComponent_4_0():void {
  var _any:any = (null as any);
}
